import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { BankEnum } from '@zaoblako/web/core/models/enums/bank.enum';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'crm-welcome-system-select-bank',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './welcome-system-select-bank.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeSystemSelectBankComponent {
  @Output() public selectBank = new EventEmitter<BankEnum>();

  public get BankEnum() {
    return BankEnum;
  }
}
